import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'
import jwtDecode from 'jwt-decode'
const Login = () => import('@/components/Login')
const Logout = () => import('@/components/Logout')

Vue.use(Router)

function loadMiscData(lskins) {
  return new Promise ( async (resolve, reject) => {
    try {
      let phonecodeid = router.app.$options.store.getters['user'].frn_phonecodeid;
      let leuserid = router.app.$options.store.getters['user'].leuserid;
      let userLskin = router.app.$options.store.getters['user'].frn_lskinid;
      if (phonecodeid) {
        await router.app.$options.store.dispatch('getUserProfileData', phonecodeid);
      }
      await router.app.$options.store.dispatch('checkUsagePolicy');
      await router.app.$options.store.dispatch('liveListenManagerRole', leuserid);
      await router.app.$options.store.dispatch('checkJiveIntegrationEnabled', leuserid);
      await router.app.$options.store.dispatch('checkVinIntegrationEnabled', lskins);
      await router.app.$options.store.dispatch('checkDSIntegrationEnabled', lskins);
      await router.app.$options.store.dispatch('checkEleadIntegrationEnabled', lskins);
      await router.app.$options.store.dispatch('checkNexhealthIntegrationEnabled', lskins);
      await router.app.$options.store.dispatch('checkResourceEnabled', userLskin);
      await router.app.$options.store.dispatch('checkRedactionEnabled', userLskin);
      await router.app.$options.store.dispatch('getCampaignData', { leuserid: leuserid, lskinid: userLskin });
      let outcomeFlag = await router.app.$options.store.dispatch('checkCallCenterOutcomeEnabled', userLskin);
      if (outcomeFlag) {
        await router.app.$options.store.dispatch('getCallCenterOutcomes', userLskin);
      }
      resolve(true);
    } catch (err) {
      console.log(err);
      reject(err);
    }
  })
}

function grabAccountData(lskins) {
  return new Promise ( async (resolve, reject) => {
    try {
      router.app.$options.store.commit({
        type: 'setLskins',
        lskins: lskins
      })
    
      if (router.app.$options.store.getters['lskins']) {
        await router.app.$options.store.dispatch('getCallCenterLskins', { lskinid: lskins })
        let lskinArray = router.app.$options.store.getters['lskins']
        await router.app.$options.store.dispatch('getAllAccounts', { lskins: lskinArray })
        await router.app.$options.store.dispatch('getTrackingLineFiltering', { lskins: lskinArray })
        await router.app.$options.store.dispatch('getPhonecodeGroups', { lskins: lskinArray });
        await router.app.$options.store.dispatch('mapPhonecodesToGroups', { lskins: lskinArray });
        resolve();
      } else {
        reject('no lskin defined');
      }
    } catch (err) {
      console.log(err);
      reject(err);
    }
  })
}

function processJWT(accessToken) {
  return new Promise ( (resolve, reject) => {
    try {
      let lskins;
      let phonecodeid;
      if (accessToken) {
        router.app.$options.store.dispatch('setUserAndTokens', { accessToken: accessToken })
        if (router.app.$options.store.getters['user'].exp < new Date()) {
          window.location.href = 'http://www.carwars.com/platform_allies/index.cfm'
        }
        lskins = jwtDecode(accessToken).data.user.frn_lskinid.toString();
      } else {
        window.location.href = 'http://www.carwars.com/platform_allies/index.cfm'
      }
    
      resolve({ lskins, phonecodeid });
    } catch (err) {
      console.log(err);
      reject(err);
    }
  })
}

let routes = [
  { path: '/',
    replace: true,
    component: Main,
    props: true,
    meta: { requiresAuth: true },
    beforeEnter: async (to, from, next) => {
      let accessToken = localStorage.getItem('accessToken') ? localStorage.getItem('accessToken') : null
      let jwtPromise = await processJWT(accessToken);
      let lskins = jwtPromise.lskins;

      // Push login route if the JWT doesn't return a user
      if (!router.app.$options.store.getters['user']) {
        next({
          path: '/login',
          replace: true
        })
      }

      // Open deep link if notification clickthrough was used
      if (to.query && to.query.openConversation) {
        router.app.$options.store.commit('setDeepLinkConversationId', { id: to.query.openConversation });
      }

      // Load this data into store before rendering the main route
      await grabAccountData(lskins);  
      await loadMiscData(lskins);

      // Render route once JWT is decoded
      next();
    }
  },
  { 
    path: '/login', 
    component: Login, 
    props: true, 
    meta: { title: 'Login' },
    beforeEnter: async (to, from, next) => {
      // Open deep link if notification clickthrough was used
      if (to.query && to.query.openConversation) {
        router.app.$options.store.commit('setDeepLinkConversationId', { id: to.query.openConversation });
      }

      next();
    }
  },
  { path: '/logout', component: Logout }
]

const router = new Router({
  routes: routes
})

export default router
